import { MasonryImageBannerRenderer } from '@leagueplatform/masonry-renderers';

export const SidebarImageBanner: typeof MasonryImageBannerRenderer = (
  props,
) => (
  <MasonryImageBannerRenderer
    {...props}
    css={{
      '& > div': {
        '--GDS--imageGap': 0,
      },
      '.GDS-image': {
        borderRadius: '$card',
        height: 'auto',
      },
    }}
  />
);
